import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TableModule } from 'primeng/table';
import { CardModule } from 'primeng/card';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextarea } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputSwitchModule } from 'primeng/inputswitch';
import { PasswordModule } from 'primeng/password';
import { DropdownModule } from 'primeng/dropdown';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfigurationsListComponent } from './configurations-list/configurations-list.component';
import { ConfigurationsDetailComponent } from './configurations-detail/configurations-detail.component';
import { ConfigurationsRoutingModule } from './configurations-routing.module';

import { CoreModule } from 'src/app/core/core.module';
@NgModule({ declarations: [
        ConfigurationsListComponent,
        ConfigurationsDetailComponent
    ], imports: [CoreModule,
        ConfigurationsRoutingModule,
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        TableModule,
        CardModule,
        ButtonModule,
        InputTextModule,
        InputTextarea,
        InputNumberModule,
        InputSwitchModule,
        PasswordModule,
        DropdownModule,
        ConfirmDialogModule,
        CheckboxModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class ConfigurationsModule { }
